import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NewFeatureInfoPopUp from './NewFeatureInfoPopUp';
import giftCardDetailsPageMessagesV2 from '../giftCardDetailsPage_v2/messages/giftCardDetailsPageMessages';
import SkeletonLoader from '../loader/SkeletonLoader';
import { getLoaderStatus } from '../loader/loaderSelector';


const NewFeatureBullet = ({
    intl, openNewFeatureDialog, handleIconClick, isLoading,
    handleCloseNewFeatureModel, newFeaturePopUpDescriptionText, newFeaturePopUpTitle, newFeatureSummaryText
}) => {
    const handleClose = () => {
        handleCloseNewFeatureModel(false);
    };

    return (
        <SkeletonLoader
            isLoading={isLoading}
            skeletonProps={{
                animation: 'wave',
                variant: 'rectangular',
                className: 'skeletonclass',
                width: '100%',
                height: 50
            }}
        >
            <Box
                className='description-container new-feature-bullet-container'
                onClick={handleIconClick}
            >
                <Box className='new-feature-bullet-highlight'>
                    <Typography component="span" className='new-feature-bullet-highlight-text'>
                        {intl.formatMessage(
                            giftCardDetailsPageMessagesV2.newFeatureHighlightText
                        )}
                    </Typography>
                </Box>
                <Box className='new-feature-bullet-description'>
                    <Typography className='new-feature-bullet-description-text'>
                        {newFeatureSummaryText}
                    </Typography>
                </Box>
                <button aria-label="more info" type="button" className='new-feature-bullet-info-icon'>
                    <InfoOutlinedIcon
                        className='custom-tooltip'
                    />
                </button>
            </Box>
            {openNewFeatureDialog && (
                <NewFeatureInfoPopUp
                    isOpen={openNewFeatureDialog}
                    handleCloseModel={handleClose}
                    title={newFeaturePopUpTitle}
                    message={
                        newFeaturePopUpDescriptionText
                    }
                />
            )}
        </SkeletonLoader>
    );
};

NewFeatureBullet.defaultProps = {
    newFeatureSummaryText: '',
    newFeaturePopUpTitle: '',
    newFeaturePopUpDescriptionText: ''
};

NewFeatureBullet.propTypes = {
    
    intl: intlShape.isRequired,
    newFeatureSummaryText: PropTypes.string,
    newFeaturePopUpTitle: PropTypes.string,
    newFeaturePopUpDescriptionText: PropTypes.string,
    openNewFeatureDialog: PropTypes.bool.isRequired,
    handleIconClick: PropTypes.func.isRequired,
    handleCloseNewFeatureModel: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    isLoading: getLoaderStatus(state)
});

export default connect(mapStateToProps)(
    injectIntl(NewFeatureBullet)
);
